import React, { Fragment } from 'react';
import ContactSection from '../../components/ContactSection';
import Header from '../../components/Header2/Header2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg';
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/music-icon.svg';
import bImg1 from '../../images/hero/contact-img.png';
import bImg2 from '../../images/shape/brd_shape.png';
import Header2 from '../../components/Header2/Header2';

const TeamPage = (props) => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 Contact="Contact Us" />
        <section
          className="page-title  pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap sd-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-9 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" /> Contact Us
                    </span>
                    <h2 className="title">
                      Get in Touch with Waste Pilot for <br /> Hassle-Free
                      Dumpster Rentals <br /> and Expert Waste Solutions
                    </h2>
                  </div>
                </div>
                <div className="col-lg-3 mt-30">
                  <div className="sd-right-img pos-rel">
                    <img
                      src={
                        'https://innomax-react.netlify.app/static/media/contact-img.4d252e56a8e2e092adcb.png'
                      }
                      alt=""
                    />
                    <div className="sd-arrow-shape style-3">
                      <img className="xbzoominzoomup" src={bImg2} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ContactSection />
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TeamPage;
